import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
const getTypographyStyle = (variant) => {
    switch (variant) {
        case "section":
            return "typography.headline.22.bold";
        case "main":
            return "typography.headline.24.bold";
    }
};
export const Title = ({ title, variant, testId, heading = "h2", hasMargin = true, id, }) => {
    const typography = getTypographyStyle(variant);
    if (!title)
        return null;
    return (_jsx(Box, { as: heading, id: id, marginTop: "0", marginBottom: hasMargin ? "spacing.16" : "spacing.none", testId: testId, typography: typography, unsafe_style: {
            scrollMarginTop: "140px", // TODO: Replace hardcoded value with a shared constant to keep scroll alignment consistent
        }, children: title }));
};
